export default "__VITE_ASSET__D3uXg9s1__"